<template>
  <div>
    <PCNavbar selectIndex="7"/>
    <MobileNavBar :currentActive="6" />
    <NewsCenter/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import NewsCenter from '@/components/news_center/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    NewsCenter
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>